module.exports = __webpack_public_path__ + "img/lock.13faa1fe.svg";